export default __webpack_public_path__ + "static/media/pools-placeholder-light.5a8f88a8.png";